import { useEffect } from 'react';

type UseBrowserTitleOptions = {
    appendBrand?: boolean;
};

function useBrowserTitle(title: string, {
    appendBrand = true,
}: UseBrowserTitleOptions = {}) {
    useEffect(() => {
        document.title = appendBrand ? `${title} | Detector Inspector` : title;
    }, [appendBrand, title]);
}

export { useBrowserTitle, UseBrowserTitleOptions };
